customElements.get("media-gallery") || customElements.define("media-gallery", class extends HTMLElement {
	constructor() {
		super(), this.selectors = {
			container: ".m-main-product--wrapper",
			slider: ".swiper-container",
			sliderPagination: ".swiper-pagination",
			sliderPrevEl: ".swiper-button-prev",
			sliderNextEl: ".swiper-button-next",
			sliderPrevThumbEl: ".swiper-button-thumb-prev",
			sliderNextThumbEl: ".swiper-button-thumb-next",
			navSlider: ".nav-swiper-container",
			medias: [".m-product-media--item"],
			mediaWrapper: ".m-product-media--wrapper",
			mediaZoomIns: [".m-product-media__zoom-in"],
			videos: [".media-video"],
			variantIdNode: '[name="id"]',
			featuredImage: ".m-product-media"
		}, this.productSlideCommonConfigs = {
			loop: !0
		}, this.productSlideConfigs = {
			mobile: {
				autoHeight: !0,
				loop: !0
			},
			"quick-view": {
				autoHeight: !0
			},
			"layout-5": {
				...this.productSlideCommonConfigs,
				slidesPerView: 1,
				slidesPerGroup: 1,
				watchSlidesProgress: !0,
				watchSlidesVisibility: !0,
				breakpoints: {
					768: {
						slidesPerView: 2,
						slidesPerGroup: 1,
						spaceBetween: 10
					}
				}
			},
			"layout-7": {
				...this.productSlideCommonConfigs,
				slidesPerView: 3,
				speed: 500,
				centeredSlides: !0
			}
		}, this.container = this.closest(this.selectors.container), this.domNodes = queryDomNodes(this.selectors, this), this.enableVideoAutoplay = "true" === this.dataset.enableVideoAutoplay, this.enableImageZoom = "true" === this.dataset.enableImageZoom, this.enableVariantGroupImages = "true" === this.dataset.enableVariantGroupImages, this.onlyMedia = "true" === this.dataset.onlyMedia, this.container && (this.view = this.container.dataset.view || "product-template"), this.section = this.closest(`[data-section-id="${this.sectionId}"]`), this.layout = this.dataset.layout, this.setupData()
	}
	getProductSliderConfig(e) {
		const t = this.productSlideConfigs[e] || this.productSlideConfigs["layout-4"];
		return {
			...this.productSlideCommonConfigs,
			...t
		}
	}
	setupData() {
		this.productHandle = this.dataset.productHandle, this.productUrl = this.dataset.productUrl, this.productData = this.getProductJson();
		const {
			variants: e
		} = this.productData || {};
		if (!this.productData || !e) return;
		const t = this.container.querySelector(this.selectors.variantIdNode);
		if (!t) return;
		let i = Number(t.value) || this.productData.selected_or_first_available_variant.id;
		const s = e.find((e => e.id === i)) || e[0];
		if (this.productData.initialVariant = s, !this.productData.selected_variant && t.dataset.selectedVariant) {
			const i = Number(t.dataset.selectedVariant);
			this.productData.selected_variant = e.find((e => e.id === i))
		}
		this.init()
	}
	init() {
		const e = this.container.querySelector("variant-picker");
		switch (this.view) {
			case "product-template":
				this.mediaMode = "grid-column", this.handlePhotoswipe(), this.initPhotoswipe(), this.initSlider();
				break;
			case "featured-product":
				this.initSlider();
				break;
			case "card":
			case "sticky-atc":
			case "quick-view":
				this.mediaMode = "featured-image", "quick-view" === this.view && this.initSlider()
		}(() => {
			this.handleAutoplayVideo(), e || (this.initPhotoswipe(), this.handleSlideChange(), this.removeAttribute("data-media-loading"), this.firstElementChild.style.opacity = 1)
		})()
	}
	initSlider() {
		if (!this.domNodes.slider) return;
		this.mediaMode = "slider";
		const {
			slider: e,
			sliderPagination: t,
			navSlider: i,
			sliderNextEl: s,
			sliderPrevEl: a,
			sliderNextThumbEl: j,
			sliderPrevThumbEl: p
		} = this.domNodes, o = this.productData.initialVariant && this.productData.initialVariant.featured_media && this.productData.initialVariant.featured_media.position - 1 || 0, r = this.getNavSliderConfig(o);
		j?.addEventListener("click", function () {
            s.click();
        })
        p?.addEventListener("click", function () {
            a.click();
        })
		this.navSlider = i ? new MinimogLibs.Swiper(i, r) : null;
		const d = this.getMainSliderConfig(o, {
			nextEl: s,
			prevEl: a,
			sliderPagination: t
		});
		this.slider = new MinimogLibs.Swiper(e, d), this.enableVariantGroupImages || this.handleSlideChange()
	}
	getNavSliderConfig(e) {
		return {
			loop: !1,
			initialSlide: e,
			slidesPerView: 5,
			freeMode: !0,
			spaceBetween: "layout-6" === this.layout ? 5 : 10,
			threshold: 2,
			loop: true,
			centeredSlides: true,
			watchSlidesVisibility: !0,
			watchSlidesProgress: !0,
			breakpoints: {
				1024: {
					direction: "layout-6" === this.layout ? "vertical" : "horizontal"
				}
			},
			on: {
				init: () => this.domNodes.navSlider.style.opacity = 1
			}
		}
	}
	getMainSliderConfig(e, {
		nextEl: t,
		prevEl: i,
		sliderPagination: s
	}) {
		const a = this.navSlider ? {
			thumbs: {
				swiper: this.navSlider
			}
		} : {};
		return {
			...this.getProductSliderConfig(this.layout),
			initialSlide: e,
			autoHeight: !0,
			navigation: {
				nextEl: t,
				prevEl: i
			},
			threshold: 2,
			loop: !this.enableVariantGroupImages,
			pagination: {
				el: s,
				clickable: !0,
				type: "bullets"
			},
			...a,
			on: {
				init: () => {
					this.domNodes.slider.style.opacity = 1, this.domNodes = queryDomNodes(this.selectors, this.container), requestAnimationFrame((() => {
						window.dispatchEvent(new Event("resize"))
					}))
				}
			}
		}
	}
	handleSlideChange() {
		this.slider && this.slider.on("slideChange", (e => {
			window.pauseAllMedia(this);
			const {
				slides: t,
				activeIndex: i
			} = e, s = t[i];
			s && this.playActiveMedia(s);
			const a = [i];
			["layout-5", "layout-7"].includes(this.layout) && a.push(i + 1);
			const o = a.some((e => {
				const i = t[e];
				return i && "model" === i.dataset.mediaType
			}));
			this.toggleSliderDraggableState(!o)
		}))
	}
	toggleSliderDraggableState(e) {
		this.slider.allowTouchMove !== e && (this.slider.allowTouchMove = e)
	}
	handleAutoplayVideo() {
		const e = e => {
			const t = e.dataset.mediaType;
			if ("video" === t || "external_video" === t) {
				const t = e.querySelector("deferred-media");
				t && "true" === t.dataset.autoPlay && t.loadContent(!1)
			}
		};
		if ("slider" === this.mediaMode) {
			const {
				slides: t,
				activeIndex: i
			} = this.slider, s = t[i];
			s && e(s)
		} else {
			this.querySelectorAll(".m-product-media--item").forEach(e)
		}
	}
	playActiveMedia(e) {
		const t = e.querySelector("deferred-media");
		if (!t || "true" !== t.dataset.autoPlay) return;
		t.hasAttribute("loaded") || t.loadContent(!1);
		(e => {
			if (e.classList.contains("js-youtube") || e.classList.contains("js-vimeo")) {
				const t = "youtube" === (e.classList.contains("js-youtube") ? "youtube" : "vimeo") ? "mute=1" : "muted=1",
					i = e.src.includes("?") ? "&" : "?";
				e.src += `${i}autoplay=1&${t}`
			} else e.play()
		})(t.querySelector("video, model-viewer, iframe"))
	}
	handlePhotoswipe(e = []) {
		if (!this.enableImageZoom) return;
		const t = [...this.querySelectorAll(".m-product-media--item:not(.swiper-slide-duplicate)")].map((e => {
				const {
					mediaType: t,
					index: i
				} = e.dataset;
				if ("image" === t) {
					const {
						mediaSrc: t,
						mediaWidth: s,
						mediaHeight: a,
						mediaAlt: o
					} = e.querySelector(".m-product-media").dataset;
					return {
						src: t,
						width: parseInt(s),
						height: parseInt(a),
						alt: o,
						id: i
					}
				}
				return {
					html: `<div class="pswp__${t}">${e.innerHTML}</div>`,
					type: t,
					id: i
				}
			})),
			i = {
				dataSource: e.length ? e : t,
				bgOpacity: 1,
				close: !1,
				zoom: !1,
				arrowNext: !1,
				arrowPrev: !1,
				counter: !1,
				preloader: !1,
				pswpModule: MinimogLibs.PhotoSwipeLightbox.PhotoSwipe
			};
		this.lightbox = new MinimogLibs.PhotoSwipeLightbox(i), this.lightbox.addFilter("thumbEl", ((e, {
			id: t
		}, i) => this.querySelector(`[data-index="${t}"]:not(.swiper-slide-duplicate) img`) || e)), this.lightbox.addFilter("placeholderSrc", ((e, {
			data: {
				id: t
			}
		}) => {
			const i = this.querySelector(`[data-index="${t}"]:not(.swiper-slide-duplicate) img`);
			return i ? i.src : e
		})), this.lightbox.on("change", (() => {
			if (window.pauseAllMedia(this), this.slider) {
				const {
					currIndex: e
				} = this.lightbox.pswp, t = this.enableVariantGroupImages ? "slideTo" : "slideToLoop";
				this.slider[t](e, 100, !1)
			}
		})), this.lightbox.on("pointerDown", (e => {
			"model" === this.lightbox.pswp.currSlide.data.type && e.preventDefault()
		}));
		const s = [{
			name: "m-close",
			order: 11,
			isButton: !0,
			html: '<svg class="m-svg-icon--large" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>',
			onClick: (e, t, i) => i.close()
		}, {
			name: "m-arrowNext",
			order: 12,
			isButton: !0,
			html: '<svg fill="currentColor" width="14px" height="14px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg>',
			onClick: (e, t, i) => i.next()
		}, {
			name: "m-arrowPrev",
			order: 10,
			isButton: !0,
			html: '<svg width="14px" height="14px" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"></path></svg>',
			onClick: (e, t, i) => i.prev()
		}];
		this.lightbox.on("uiRegister", (() => {
			this.lightbox.pswp.ui.registerElement(s[0]), this.onlyMedia || s.slice(1).forEach((e => this.lightbox.pswp.ui.registerElement(e)))
		}))
	}
	initPhotoswipe() {
		if (!this.enableImageZoom) return;
		this.lightbox.init();
		addEventDelegate({
			selector: this.selectors.medias[0],
			context: this,
			handler: (e, t) => {
				e.preventDefault();
				const i = t.classList.contains("media-type-image"),
					s = e.target.closest(this.selectors.mediaZoomIns[0]);
				if (i || s) {
					const e = Number(t.dataset.index) || 0;
					this.lightbox.loadAndOpen(e)
				}
			}
		})
	}
	setActiveMedia(e) {
		if (e) switch (this.mediaMode) {
			case "slider":
				this.setActiveMediaForSlider(e);
				break;
			case "featured-image":
				this.setActiveMediaForFeaturedImage(e);
				break;
			default:
				this.handleGalleryMode(e)
		}
	}
	setActiveMediaForSlider(e) {
		if (e.featured_media && this.slider && this.slider.wrapperEl) {
			const t = e.featured_media.position || 0;
			this.slider.slideToLoop(t - 1)
		}
	}
	setActiveMediaForFeaturedImage(e) {
		if (e.featured_image) {
			const t = e.featured_image.src,
				{
					featuredImage: i
				} = this.domNodes,
				s = i.querySelector("img");
			s && t && (s.src = t)
		}
	}
	handleGalleryMode(e) {
		if ("featured-product" !== this.view && e && e.featured_media) {
			const t = this.querySelector(`[data-media-id="${e.featured_media.id}"]`);
			t && this.scrollIntoView(t)
		}
	}
	scrollIntoView(e) {
		e.scrollIntoView({
			behavior: "smooth"
		})
	}
	getProductJson() {
		const e = this.container.querySelector("#productData[type='application/json']");
		if (!e) throw new Error("Product data element not found in the container.");
		try {
			return JSON.parse(e.textContent)
		} catch (e) {
			return null
		}
	}
});

